import { Box, Button, Stack, Typography } from "@mui/material";
import { AccessDeniedImage } from "Common/Assets";
import { RouterLinkBehavior } from "Common/Components";

interface IAccessDenied {
  title: string;
  description: string;
}

export const AccessDenied = (props: IAccessDenied) => {
  const { title, description } = props;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <AccessDeniedImage
          sx={(theme) => ({
            fontSize: theme.spacing(25),
          })}
        />
        <Stack spacing={1} sx={{ alignItems: "center" }}>
          <Typography variant="h5" color="primary.main">
            {title}
          </Typography>

          <Typography sx={{ textAlign: "center", color: "grey.600" }}>{description}</Typography>
        </Stack>
        <Button
          sx={{
            mt: 4,
          }}
          component={RouterLinkBehavior}
          to={import.meta.env.VITE_LANDING_PAGE_URL}
        >
          Back to Home
        </Button>
      </Box>
    </Box>
  );
};
